import { apiGetArticleTags } from 'api/articleTags/apiGetArticleTags';
import { modulId } from 'modules/permanent/modulId';
import dynamic from 'next/dynamic';

const SearchForTag = dynamic(() => import('modules/permanent/pages/searchForTag'));

export default SearchForTag;

export async function getServerSideProps({
  locale,
  params: { tag },
}: {
  locale: string;
  params: any;
}) {
  const { items: tagData } = await apiGetArticleTags({ tag_id: tag, modulId }, locale);

  return {
    props: {
      messages: require(`languages/${locale}/pages/searchForTag.js`).searchForTag,
      tagData,
      isPermanent: true,
      modulId,
      revalidate: 84600,
      locale: locale,
    },
  };
}
